var React = require('react');

function IconFaq5 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33.5 31.9941V21.9941M9.5 31.9941V21.9941M37.5 6.99414H5.5M35.5 0.994141H7.5M5.5 12.9941H37.5C39.71 12.9941 41.5 14.7841 41.5 16.9941V36.9941C41.5 39.2041 39.71 40.9941 37.5 40.9941H5.5C3.29 40.9941 1.5 39.2041 1.5 36.9941V16.9941C1.5 14.7841 3.29 12.9941 5.5 12.9941ZM25.0356 23.4585C26.9882 25.4112 26.9882 28.577 25.0356 30.5296C23.083 32.4822 19.9172 32.4822 17.9645 30.5296C16.0119 28.577 16.0119 25.4112 17.9645 23.4585C19.9172 21.5059 23.083 21.5059 25.0356 23.4585Z","stroke":"#ffffff","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconFaq5.defaultProps = {"viewBox":"0 0 43 42","fill":"none"};

module.exports = IconFaq5;

IconFaq5.default = IconFaq5;
